module.exports = __webpack_public_path__ + "img/re-ur3.27e1f8e1.jpg";